import React from "react";
import { useTranslations } from "next-intl";

const PrivacyYourRights = () => {
  const t = useTranslations("PrivacyPolicy");
  return (
    <div className="mb-4">
      <h2 className="sub-heading mb-4 text-2xl ">{t("your_rights_title")}</h2>
      <p className="text-lg mb-4">{t("your_rights_intro")}</p>
      <ul className="list-disc mb-4 pl-5 flex flex-col gap-1 text-lg">
        <li>
          <strong className="font-extrabold">{t("your_rights_item1_title")}</strong> –{" "}
          <span dangerouslySetInnerHTML={{ __html: t.raw("your_rights_item1_description") as string }} />
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item2_title")}</strong> – {t("your_rights_item2_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item3_title")}</strong> – {t("your_rights_item3_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item4_title")}</strong> – {t("your_rights_item4_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item5_title")}</strong> – {t("your_rights_item5_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item6_title")}</strong> – {t("your_rights_item6_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item7_title")}</strong> – {t("your_rights_item7_description")}
        </li>
        <li>
          <strong className="font-extrabold">{t("your_rights_item8_title")}</strong> – {t("your_rights_item8_description")}
        </li>
      </ul>
      <p className="text-lg mb-4">{t("your_rights_footer")}</p>
    </div>
  )
};

export { PrivacyYourRights };
